import { Fragment, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

import { sendFax } from "../../../../../features/fax/fax";

import { inputValueToInt } from "../../../../../utils/utils"

import { Checkbox, FormControl, FormControlLabel, MenuItem, OutlinedInput, Radio, Select } from "@mui/material";
import PdfPreview from "../../../../../components/PdfPreview";
import { createVerticalOrderFormPDF } from "../../../../../features/pdf/VerticalOrderFormPDF";
import { createHorizontalOrderFormPDF } from "../../../../../features/pdf/HorizontalOrderFormPDF";
import { SelectDestinationDrawer } from "../../../../../components/drawers/SelectDestinationDrawer";
import { createVerticalOrderCheckFormPDF } from "../../../../../features/pdf/VerticalOrderCheckFormPDF";
import { createHorizontalOrderCheckFormPDF } from "../../../../../features/pdf/HorizontalOrderCheckFormPDF";
import { postMarketPriceUpdateShippingDateInfoAPI } from "../../../../../http/api/MarketPriceAPI";
import { getShopsGroupingByCustomer } from "../../../../../utils/customerShop";
import { createGeneralOrderFormPDF } from "../../../../../features/pdf/GeneralOrderFormPDF";
import { createGeneralOrderCheckFormPDF } from "../../../../../features/pdf/GeneralOrderCheckFormPDF";
import { getUsingDirectorEmployeePartition, getUsingDeliveryPrice, validatePrintPageStr } from "../../../../../utils/orderForm";
import { controlPdfSettingConstraint } from "./SettingConstraints";

// FAXダイアログ　出力設定
export function OrderFormPdfSettingPart({onLoadPdfSetting, shippingDateIsInterval, onChangePdfSetting}) {
  // 印刷ページ入力State
  const [printPageInput, setPrintPageInput] = useState("");
  
  const [pdfSetting, setPdfSetting] = useState(onLoadPdfSetting());

  const onChangePdfPropSetting = (prop) => (event) => {
    let newPdfSetting = {...pdfSetting, [prop]: event.target.value};

    setPdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
    onChangePdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
  }

  const onChangePdfSettingWithArray = (settingArray) => (event) => {
    let newPdfSetting = {...pdfSetting, ...settingArray};

    setPdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
    onChangePdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
  }

  const toggleSetting = (prop) => (event) => {
    let newPdfSetting = {...pdfSetting, [prop]: event.target.checked};
    
    setPdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
    onChangePdfSetting(controlPdfSettingConstraint(newPdfSetting, shippingDateIsInterval, false));
  }


  const onChangePrintPageInput = (event) => {
    setPrintPageInput(event.target.value);
  }

  return (
    <Box border='black 1px solid' padding={1} paddingBottom={0}>
      <Typography>出力形式設定</Typography>
      <Grid container>
        <Grid item xs={9.5}>
          <table>
            <tr>
              <td>
                <Typography fontWeight={600}>列数・向き</Typography>
              </td>
              <td colSpan={2}>
                <FormControl>
                  <Select
                    sx={{ width: 200 }}
                    value={pdfSetting.orderFormColumnCountDirectionCd}
                  >
                    <MenuItem
                      key={"column-direction-col-1-vertcal"}
                      value={"1"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "1", columnNumber : "1", direction : "1", general: "2"})}
                    >
                      1列・縦むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-1-horizontal"}
                      value={"3"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "3", columnNumber : "1", direction : "2", general: "2"})}
                    >
                      1列・横むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-2-vertical"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "5", columnNumber : "2", direction : "1", general: "2"})}
                      value={"5"}
                    >
                      2列・縦むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-2-horizontal"}
                      value={"2"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "2", columnNumber : "2", direction : "2", general: "2"})}
                    >
                      2列・横むき
                    </MenuItem>
                    <MenuItem
                      key={"column-direction-col-3-horizontal"}
                      value={"4"}
                      onClick={onChangePdfSettingWithArray({orderFormColumnCountDirectionCd: "4", columnNumber : "3", direction : "2", general: "1", shopSummary: "1"})}
                      disabled={pdfSetting.isUsingSellingPrice || pdfSetting.isUsingDeliveryPrice}
                    >
                      3列・横むき
                    </MenuItem>
                  </Select>
                </FormControl>
              </td>
              <td>
                <Typography fontWeight={600}>あて名出力</Typography>
              </td>
              <td colSpan={2}>
                <FormControl>
                  <Select
                    sx={{ width: 200 }}
                    value={pdfSetting.destinationOutputCd}
                    onChange={onChangePdfPropSetting("destinationOutputCd")}
                  >
                    <MenuItem
                      key={"destination-output-1"}
                      value={"1"}
                    >
                      市況価格表名 / 取引先名
                    </MenuItem>
                    <MenuItem
                      key={"destination-output-2"}
                      value={"2"}
                    >
                      「御取引先様各位」
                    </MenuItem>
                    <MenuItem
                      key={"destination-output-3"}
                      value={"3"}
                    >
                      店名記入スペース
                    </MenuItem>
                  </Select>
                </FormControl>
              </td>
            </tr>
            <tr>
              <td width="150px">
                <Typography fontWeight={600}>店舗表示</Typography>
              </td>
              <td width="130px">
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="1店舗ごと"
                  checked={pdfSetting.shopSummary === "1"}
                  onChange={onChangePdfPropSetting("shopSummary")}
                />
              </td>
              <td  width="130px">
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="まとめる"
                  checked={pdfSetting.shopSummary === "2"}
                  disabled={
                    (pdfSetting.direction == "1" && pdfSetting.columnNumber == "2")
                      || (pdfSetting.direction == "2" && pdfSetting.columnNumber == "3")
                      || pdfSetting.datePartition
                  }
                  onChange={onChangePdfPropSetting("shopSummary")}
                />
              </td>
              <td width="150px">
                <Typography fontWeight={600}>種別ごと改ページ</Typography>
              </td>
              <td width="130px">
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="する"
                  checked={pdfSetting.productTypePartition === "1"}
                  onChange={onChangePdfPropSetting("productTypePartition")}
                />
              </td>
              <td width="130px">
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="しない"
                  checked={pdfSetting.productTypePartition === "2"}
                  onChange={onChangePdfPropSetting("productTypePartition")}
                />
              </td>
            </tr>
            <tr>
              <td>
                <Typography fontWeight={600}>締め切り時間出力</Typography>
              </td>
              <td>
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="する"
                  checked={pdfSetting.deadlineHourOutput === "1"}
                  onChange={onChangePdfPropSetting("deadlineHourOutput")}
                />
              </td>
              <td>
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="しない"
                  checked={pdfSetting.deadlineHourOutput === "2"}
                  onChange={onChangePdfPropSetting("deadlineHourOutput")}
                />
              </td>
              <td>
                <Typography fontWeight={600}>個人連絡先出力</Typography>
              </td>
              <td>
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="する"
                  checked={pdfSetting.contact === "1"}
                  onChange={onChangePdfPropSetting("contact")}
                />
              </td>
              <td>
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="しない"
                  checked={pdfSetting.contact === "2"}
                  onChange={onChangePdfPropSetting("contact")}
                />
              </td>
              <td width="150px">
                <Typography fontWeight={600}>
                  注文数量出力
                </Typography>
              </td>
              <td width="130px">
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="する"
                  checked={pdfSetting.orderQuantityOutput === "1"}
                  onChange={onChangePdfPropSetting("orderQuantityOutput")}
                />
              </td>
              <td width="130px">
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="しない"
                  checked={pdfSetting.orderQuantityOutput === "2"}
                  onChange={onChangePdfPropSetting("orderQuantityOutput")}
                />
              </td>
            </tr>
          </table>
        </Grid>
        <Grid item xs={2.5}>
          <Grid container>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox />}
                label="注文のない商品を表示しない"
                checked={pdfSetting.skipNoOrder}
                onChange={toggleSetting("skipNoOrder")}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox />}
                label="日付別に分ける"
                checked={pdfSetting.datePartition}
                onChange={toggleSetting("datePartition")}
                disabled={pdfSetting.columnNumber !== "1" || !shippingDateIsInterval}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox />}
                label="備考を表示しない"
                checked={pdfSetting.skipRemark}
                onChange={toggleSetting("skipRemark")}
              />
            </Grid>
          </Grid>					
        </Grid>			
      </Grid>
      <hr />
      <Grid container alignItems="center" spacing={1} marginBottom={1}>
        <Grid item xs="auto">
          <FormControlLabel
            control={<Checkbox />}
            label="再送"
            checked={pdfSetting.isSendingAgain}
            onChange={toggleSetting("isSendingAgain")}
          />
        </Grid>
        <Grid item xs="auto">
          <Typography fontWeight={600}>印刷ページ</Typography>
        </Grid>
        <Grid item xs="auto">
          <OutlinedInput
            value={printPageInput}
            onChange={onChangePrintPageInput}
          />
        </Grid>
        <Grid item xs="auto">
          <Button
            variant="contained"
            onClick={onChangePdfSettingWithArray({...pdfSetting, printPageStr: printPageInput})}
            disabled={!validatePrintPageStr(printPageInput)}
          >変更</Button>
        </Grid>
        <Grid item xs="auto" marginLeft={1}>
          <Typography>
            (例: 1-3,8,10-12)
          </Typography>
        </Grid>
      </Grid>  
    </Box>
  )
}
